export const Role = {
    User: 'User',
    Admin: 'Admin',
    Manager: 'Manager',
    Reserves: 'Reserves'
}

export const RoleFR = {
    User: 'Usager',
    Admin: 'Admin',
    Manager: 'Manager',
    Reserves: 'Reserves'
}

export const AllRoles = [Role.User, Role.Admin, Role.Manager, Role.Reserves]